import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type ComponentSize = 'large' | 'medium' | 'default' | 'small';

@Component({
  // Inherited components ignore template property
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  host: {
    '[class.size-large]': 'size() === "large"',
    '[class.size-default]': 'size() === "default" || size() === "medium"',
    '[class.size-small]': 'size() === "small"',
  },
})
export class ComponentWithSizesComponent {
  /**
   * Control the size of the component.
   *
   * Options are 'large' | 'medium' | 'default' | 'small'
   */
  public readonly size = input<ComponentSize>('default');
}
